// Job status badge colours, shared by the Jobs board and the header search.
export const STATUS_STYLE = {
  complete:    'bg-[#6B9B76]/15 text-[#6B9B76]',
  in_progress: 'bg-[#C4A561]/15 text-[#C4A561]',
  scheduled:   'bg-[#4575A8]/15 text-[#4575A8]',
  cancelled:   'bg-[#AD5D5D]/15 text-[#AD5D5D]',
  lead:        'bg-[#71717A]/15 text-muted-foreground',
};

export const statusStyle = (status) => STATUS_STYLE[status] || STATUS_STYLE.lead;
export const statusLabel = (status) => (status || 'scheduled').replace('_', ' ');
